import { IconButton } from '@magicschool/spellbook/components/IconButton';
import { Tooltip } from '@magicschool/spellbook/components/Tooltip';

export type ExpandRowTriggerProps = {
  expandedContentId: string;
  isExpanded?: boolean;
  onClick: () => void;
  tooltipLabels?: {
    expandableRowTriggerExpandedLabel?: string;
    expandableRowTriggerCollapsedLabel?: string;
  };
};

export const ExpandRowTrigger = ({
  expandedContentId,
  isExpanded = false,
  onClick,
  tooltipLabels: { expandableRowTriggerExpandedLabel, expandableRowTriggerCollapsedLabel } = {},
}: ExpandRowTriggerProps) => (
  <Tooltip mode="label">
    <Tooltip.Trigger>
      <IconButton
        aria-controls={expandedContentId}
        aria-expanded={isExpanded}
        color="neutral"
        name={isExpanded ? 'chevron-up' : 'chevron-down'}
        onClick={onClick}
        shape="default"
        variant="ghost"
        size="sm"
      />
    </Tooltip.Trigger>
    <Tooltip.Content>{isExpanded ? expandableRowTriggerExpandedLabel : expandableRowTriggerCollapsedLabel}</Tooltip.Content>
  </Tooltip>
);
